module.exports = __webpack_public_path__ + "img/arrow-right.a493a32b.svg";